export default __webpack_public_path__ + "img/c1003.7897480f.svg";